// extracted by mini-css-extract-plugin
module.exports = {"spaced":"ActivationModal_spaced_ySnce","footer":"ActivationModal_footer_1NjvV"};